import { DateRange } from './date';

export class MerchantUser {
    id: number;
    mobileNo: string;
    countryCode: string;
    uid: string;
    displayName: string;
    fullName: string;
    referralCode: string;
    isEmployee: boolean;
    emailId: string;
    emailVerified: boolean;
    lastLoginDate: string;
    tier: number;
    appCode: string;
    kycStatus: string;
    status: number;
    statusUpdatedDate: string;
    createdBy: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
}
export class Role {
    id: number;
    name: string;
}
export class MerchantUserSearch {
    createdDate: DateRange = DateRange.empty();
    id : number;
    userType = '';
    displayName = '';
    mobileNo = '';
    emailId = '';
    merchantId = '';
    locationId = '';
 }
